/**
 * Selectors for company notification preferences
 */

/**
 * Gets the allow_user_overrides setting from company notifications state
 * @param {Object} companyNotifications - The companyNotifications slice of Redux state
 * @returns {boolean} Whether users are allowed to override notification preferences
 */
export const selectAllowUserOverrides = (companyNotifications) => {
  const [firstNotificationResource] = Object.values(companyNotifications?.dropdown || {});
  return firstNotificationResource?.attributes?.allow_user_overrides ?? false;
};
